import Paper from '@mui/material/Paper';
import { IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import React from 'react';
import { useSubscribeModal } from '../../SubscribeModalContext';
import { useTranslation } from 'react-i18next';

const HillTopBanner = (props: any) => {
    const { height } = props;
    const { t, i18n } = useTranslation();
    const { open } = useSubscribeModal();

    const src: any = {
        tall: 'https://www.calpal.pro/ads/ad-hilltop-slot-300x250.html',
        short: 'https://www.calpal.pro/ads/ad-hilltop-slot-300x100.html',
    };

    return (
        <Paper className="m-4 flex flex-col p-4 relative" elevation={3}>
            <div className="absolute top-0 right-0">
                <IconButton size="small" color="primary" onClick={open}>
                    <ClearIcon fontSize="inherit" />
                </IconButton>
            </div>
            <iframe
                title="Advertizing"
                src={src[height]}
                width="300"
                height={height === 'tall' ? 260 : 110}
                style={{
                    border: 'none',
                    display: 'block',
                    margin: '0 auto',
                    padding: '0',
                }}
                sandbox={[
                    'allow-scripts',
                    'allow-same-origin',
                    'allow-popups',
                    'allow-popups-to-escape-sandbox',
                    'allow-top-navigation-by-user-activation',
                ].join(' ')}
            />
            <div
                className="text-xs text-center text-green-900 underline"
                role="button"
                onClick={open}
            >
                {t('subscribe_remove_ads')}
            </div>
        </Paper>
    );
};

export default HillTopBanner;
